import {match, Pattern} from 'ts-pattern';

import type {TestDriveSlotRequestBody} from '@dms/api/finance';
import {castTimeToDateISOString} from '@dms/shared';

import type {Nullish} from 'shared/web';

const FILLED = Pattern.string.minLength(1);

/**
 * Turns the two test drive form inputs into the request slot:
 * date + time -> ISO instant, date only -> {date}, no date -> null.
 * A time without a date is not a slot; the date must be filled first.
 */
export const buildTestDriveSlot = (
  date: Nullish | string,
  time: Nullish | string
): TestDriveSlotRequestBody | null =>
  match({date, time})
    .with({date: FILLED, time: FILLED}, ({date: filledDate, time: filledTime}) =>
      castTimeToDateISOString(filledDate, filledTime)
    )
    .with({date: FILLED}, ({date: filledDate}) => ({date: filledDate}))
    .otherwise(() => null);
